<template>
    <Header></Header>
    <Left></Left>
    <section class="container pdf_area_class">
        <div>
            <div class="area_title">
                <p>내담자 정보</p>
                <div class="area_button">
                    <button type="button" @click="window.print">
                        <img src="img/print.png" />
                        <span>PDF 출력</span>
                    </button>
                    <button type="button" @click="router.push({ name: 'clientDetail', params: { id: state.clientIdx } })">
                        <span>기초 기록으로 연계</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <ClientDetail :idx="state.clientIdx"></ClientDetail>

                    <div class="area_form_foot">
                        <div class="area_button">
                            <button type="button" @click="router.push({ name: 'counselListForClient', params: { id: state.clientIdx } })">
                                내담자의 상담기록 리스트 가기
                            </button>
                            <button type="button" @click="router.push({ name: 'counsel' })">상담목록 가기</button>

                            <template v-if="state.mode">
                                <button type="button" class="active" @click="add()">등록</button>
                            </template>
                            <template v-else>
                                <template v-if="state.hasAuth === 1">
                                    <button type="button" class="active" @click="confirmModify">저장</button>
                                </template>
                                <button
                                    v-else-if="state.hasAuth === -1 || state.hasAuth === 3"
                                    type="button"
                                    class="active"
                                    @click="showRequestAccessModal(1)"
                                >
                                    수정 권한 요청
                                </button>
                                <button v-else-if="state.hasAuth === 0" type="button" class="gray" @click="">수정 승인 대기</button>
                                <template v-else-if="state.hasAuth === 2">
                                    <button type="button" class="active" @click="showRequestAccessModal(1)">수정 재승인 요청</button>
                                    <button type="button" class="blueBtn" @click="showRejectReason(state.modify.rejectReason)">반려 사유</button>
                                </template>
                                <template v-if="state.hasDeleteAuth === 1">
                                    <button type="button" class="danger" @click="confirmRemove()">삭제</button>
                                </template>
                                <button
                                    v-else-if="state.hasDeleteAuth === -1 || state.hasDeleteAuth === 3"
                                    type="button"
                                    class="danger"
                                    @click="showRequestAccessModal(2)"
                                >
                                    삭제 권한 요청
                                </button>
                                <button v-else-if="state.hasDeleteAuth === 0" type="button" class="gray" @click="">삭제 승인 대기</button>
                                <template v-else-if="state.hasDeleteAuth === 2">
                                    <button type="button" class="gray" @click="showRequestAccessModal(2)">삭제 재승인 요청</button>
                                    <button type="button" class="blueBtn" @click="showRejectReason(state.remove.rejectReason)">반려 사유</button>
                                </template>
                            </template>

                            <button type="button" class="active" v-if="!state.mode && CommonUtils.checkAuth()" @click="confirmModify2">승인</button>

                            <button type="button" class="active" v-if="!state.mode && CommonUtils.checkAuth()" @click="confirmModify3">보완</button>

                            <button type="button" @click="reset">다시작성</button>

                            <button type="button" @click="anotherDetail(0)" v-if="state.hasPrev">이전</button>
                            <button type="button" @click="anotherDetail(1)" v-if="state.hasNext">다음</button>

                            <button type="button" @click="addForTemporary" v-if="state.mode">임시저장</button>
                        </div>

                        <div v-if="state.data.counselDetailVO.comment" class="area_comment">
                            <label>팀장 보완 요청</label>
                            <div><textarea v-model="state.data.counselDetailVO.comment" disabled style="width: 100%; height: 150px"></textarea></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="container pdf_area_class">
        <div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_form">
                        <div class="area_form_title"><p>상담내용</p></div>
                        <div class="area_form_body">
                            <div class="area_row">
                                <div class="area_col_row" style="flex-direction: row">
                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label class="starMark">1. 작성일</label></div>
                                        <div class="area_col_body">
                                            <div class="datepicker">
                                                <input
                                                    type="date"
                                                    ref="prevDate"
                                                    :value="state.data.date"
                                                    @change="onChangeDate"
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" style="width: 50%">
                                        <div class="area_col_head"><label class="starMark">2. 작성자</label></div>
                                        <div class="area_col_body">
                                            <div class="">
                                                <input
                                                    class="w250"
                                                    type="text"
                                                    v-model="state.data.csmName"
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="area_row">
                                <div class="area_col_row" style="flex-direction: row">
                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label class="starMark">3. 상담유형</label></div>
                                        <div class="area_col_body">
                                            <div class="select-wrap">
                                                <select
                                                    v-model="state.data.cstype"
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                    class="w250"
                                                >
                                                    <option value="">선택해주세요.</option>
                                                    <option v-for="item in CommonOptions.counselTypeListForCounsel" :value="item.key">
                                                        {{ item.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" style="width: 50%">
                                        <div class="area_col_head"><label class="starMark">4. 상담 대상자</label></div>
                                        <div class="area_col_body">
                                            <div class="select-wrap">
                                                <select v-model="state.data.csperson" :disabled="state.mode === false && state.hasAuth !== 1">
                                                    <option value="">선택해주세요.</option>
                                                    <option v-for="item in CommonOptions.personTargetList" :value="item.key">{{ item.name }}</option>
                                                </select>
                                            </div>

                                            <div class="" v-if="state.data.csperson === '기타'">
                                                <input
                                                    type="text"
                                                    v-model="state.data.cspersonEtc"
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">5. 상담내용</label></div>
                                <div class="area_col_body no_padding">
                                    <div class="area_col_row">
                                        <div class="form_list_wrap">
                                            <div class="form_list">
                                                <label>[5-1. 상담내용유형]</label>
                                                <div>
                                                    <div class="checkbox_wrap grid11 grid">
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypeSale === 1"
                                                                @click="state.data.cktypeSale ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>탈성매매</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypeDept === 1"
                                                                @click="state.data.cktypeDept ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>빚문제</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypeForce === 1"
                                                                @click="state.data.cktypeForce ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>폭행</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypeCareer === 1"
                                                                @click="state.data.cktypeCareer ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>진로(취업 등)</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypeBrand === 1"
                                                                @click="state.data.cktypeBrand ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>사회적 낙인</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypeHealth === 1"
                                                                @click="state.data.cktypeHealth ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>건강의료 문제</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypePolice === 1"
                                                                @click="state.data.cktypePolice ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>경찰조사</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypeLaw === 1"
                                                                @click="state.data.cktypeLaw ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>법률문제</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypeFamily === 1"
                                                                @click="state.data.cktypeFamily ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>가족문제</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypeHome === 1"
                                                                @click="state.data.cktypeHome ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>주거</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypeProblem === 1"
                                                                @click="state.data.cktypeProblem ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>자활문제</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypeEmotional === 1"
                                                                @click="state.data.cktypeEmotional ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>정서문제</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypePg === 1"
                                                                @click="state.data.cktypePg ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>사각지대PG</span>
                                                        </label>

                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                :checked="state.data.cktypeEtc === 1"
                                                                @click="state.data.cktypeEtc ^= 1"
                                                                :disabled="state.mode === false && state.hasAuth !== 1"
                                                            />
                                                            <em></em>
                                                            <span>기타</span>
                                                        </label>
                                                    </div>

                                                    <div class="" v-if="state.data.cktypeEtc === 1">
                                                        <input
                                                            type="text"
                                                            v-model="state.data.cktypeEtcText"
                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form_list">
                                                <label>[5-2. 상담제목]</label>
                                                <div class="full">
                                                    <input
                                                        type="text"
                                                        placeholder="상담 제목을 입력해주세요."
                                                        v-model="state.data.title"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form_list">
                                                <label>[5-3. 상담내용]</label>
                                                <textarea
                                                    placeholder="상담 내용을 입력해주세요."
                                                    v-model="state.data.counselDetailVO.processsts"
                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                    style="height: 300px"
                                                ></textarea>
                                                <p v-text="state.data.counselDetailVO.processsts"></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row page_avoid">
                                <div class="area_col_head"><label>6. 상담조치결과</label></div>
                                <div class="area_col_row">
                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body"><label class="starMark">지원 구분</label></div>
                                    </div>
                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <div class="radio_wrap">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="result"
                                                        :checked="state.data.result === '정서적지원'"
                                                        @click="
                                                            state.data.result = '정서적지원';
                                                            state.data.newInterventionMethod = '';
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>정서적지원</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="result"
                                                        :checked="state.data.result === '법률지원'"
                                                        @click="
                                                            state.data.result = '법률지원';
                                                            state.data.newInterventionMethod = '';
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>법률지원</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="result"
                                                        :checked="state.data.result === '의료지원'"
                                                        @click="
                                                            state.data.result = '의료지원';
                                                            state.data.newInterventionMethod = '';
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>의료지원</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="result"
                                                        :checked="state.data.result === '자활지원'"
                                                        @click="
                                                            state.data.result = '자활지원';
                                                            state.data.newInterventionMethod = '';
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>자활지원</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="result"
                                                        :checked="state.data.result === '집단프로그램'"
                                                        @click="
                                                            state.data.result = '집단프로그램';
                                                            state.data.newInterventionMethod = '';
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>집단프로그램</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="result"
                                                        :checked="state.data.result === '물적자원'"
                                                        @click="
                                                            state.data.result = '물적자원';
                                                            state.data.newInterventionMethod = '';
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>물적자원</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="result"
                                                        :checked="state.data.result === '심리지원'"
                                                        @click="
                                                            state.data.result = '심리지원';
                                                            state.data.newInterventionMethod = '';
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>심리지원</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="result"
                                                        :checked="state.data.result === '관련기관연계'"
                                                        @click="
                                                            state.data.result = '관련기관연계';
                                                            state.data.newInterventionMethod = '';
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>관련기관연계</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="result"
                                                        :checked="state.data.result === '기타'"
                                                        @click="
                                                            state.data.result = '기타';
                                                            state.data.newInterventionMethod = '';
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>기타</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <p>※ 2019년 7월 4일 수정 이전 개입방법:</p>
                                        </div>
                                    </div>

                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <div class="checkbox_wrap">
                                                <label class="black">
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newSupportingExpenseYn === 1"
                                                        @click="state.data.newSupportingExpenseYn ^= 1"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>구조지원비 사용</span>
                                                </label>

                                                <label>
                                                    (비용
                                                    <input
                                                        type="text"
                                                        v-model="state.data.newSupportingExpensePrice"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    원
                                                    <span style="color: #4d60b3"></span>
                                                    )
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col">
                                        <div class="area_col_body">
                                            <div class="checkbox_wrap">
                                                <label class="black">
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newSupportingIncreaseYn === 1"
                                                        @click="state.data.newSupportingIncreaseYn ^= 1"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>구조지원비 증액</span>
                                                </label>

                                                <label>
                                                    (비용
                                                    <input
                                                        type="text"
                                                        v-model="state.data.newSupportingIncreasePrice"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    원
                                                    <span style="color: #4d60b3"></span>
                                                    )
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <div class="checkbox_wrap">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newPrevSupportingExpense === 1"
                                                        @click="
                                                            state.data.newPrevSupportingExpense ^= 1;
                                                            state.data.newPrevMedicalPrice = 0;
                                                            state.data.newPrevLawPrice = 0;
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>구조지원비 통계 미반영</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <div>
                                                <label>
                                                    이전 의료지원 총 비용 :
                                                    <input
                                                        type="number"
                                                        v-model="state.data.newPrevMedicalPrice"
                                                        :disabled="
                                                            (state.mode === false && state.hasAuth !== 1) || state.data.newPrevSupportingExpense === 1
                                                        "
                                                    />
                                                    원
                                                    <span style="color: #4d60b3"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <div>
                                                <label>
                                                    이전 법률지원 총 비용
                                                    <input
                                                        type="number"
                                                        v-model="state.data.newPrevLawPrice"
                                                        :disabled="
                                                            (state.mode === false && state.hasAuth !== 1) || state.data.newPrevSupportingExpense === 1
                                                        "
                                                    />
                                                    원
                                                    <span style="color: #4d60b3"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <div>
                                                <label>
                                                    이전 직업훈련 총 비용
                                                    <input
                                                        type="number"
                                                        v-model="state.data.newPrevJobTrainingPrice"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    원
                                                    <span style="color: #4d60b3"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <div>
                                                <label>
                                                    이전 미파악 총 비용
                                                    <input
                                                        type="number"
                                                        v-model="state.data.newPrevNotGraspPrice"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    원
                                                    <span style="color: #4d60b3"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_body">
                                            <div>
                                                <label>
                                                    이전 의료지원 총 비용
                                                    <span
                                                        v-text="
                                                            CommonUtils.numberFormat(
                                                                Number(state.data.newPrevMedicalPrice ?? 0) +
                                                                    Number(state.data.newPrevLawPrice ?? 0) +
                                                                    Number(state.data.newPrevJobTrainingPrice ?? 0) +
                                                                    Number(state.data.newPrevNotGraspPrice ?? 0),
                                                            )
                                                        "
                                                    ></span>
                                                    원
                                                    <span style="color: #4d60b3"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col">
                                        <div class="area_col_body">
                                            <div class="w100">
                                                <label class="flex ac">
                                                    <span>이전 기관명</span>
                                                    <input
                                                        class="full"
                                                        type="text"
                                                        v-model="state.data.newPrevInstitution"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row page_avoid">
                                <div class="area_col_head"><label class="starMark">7. 개입방법</label></div>
                                <div class="area_col_row">
                                    <div class="area_col" v-if="state.data.result === '법률지원'">
                                        <div class="area_col_head"><label>법률지원</label></div>

                                        <div class="area_col_body no_padding">
                                            <div class="area_col_row">
                                                <div class="form_list_wrap">
                                                    <div class="form_list">
                                                        <label>[법률지원]</label>
                                                        <div>
                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '법률상담'"
                                                                        @click="state.data.newInterventionMethod = '법률상담'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>법률상담</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '수사동행(경찰)'"
                                                                        @click="state.data.newInterventionMethod = '수사동행(경찰)'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>수사동행(경찰)</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '수사동행(검찰)'"
                                                                        @click="state.data.newInterventionMethod = '수사동행(검찰)'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>수사동행(검찰)</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '수사의뢰'"
                                                                        @click="state.data.newInterventionMethod = '수사의뢰'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>수사의뢰</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '현장구조'"
                                                                        @click="state.data.newInterventionMethod = '현장구조'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>현장구조</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '소년보호'"
                                                                        @click="state.data.newInterventionMethod = '소년보호'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>소년보호</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '수사지원'"
                                                                        @click="state.data.newInterventionMethod = '수사지원'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>수사지원</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '소송지원'"
                                                                        @click="state.data.newInterventionMethod = '소송지원'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>소송지원</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '개입방법/법률지원/기타'"
                                                                        @click="state.data.newInterventionMethod = '개입방법/법률지원/기타'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>기타</span>
                                                                </label>
                                                                <div v-if="state.data.newInterventionMethod === '개입방법/법률지원/기타'">
                                                                    <input type="text" v-model="state.data.newInterventionMethodTxt3" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="form_list" v-if="state.data.newInterventionMethod === '소송지원'">
                                                        <label>[소송지원]</label>
                                                        <div>
                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodLaw0"
                                                                        :checked="state.data.newInterventionMethodLaw0 === '민사'"
                                                                        @click="
                                                                            state.data.newInterventionMethodLaw0 = '민사';
                                                                            state.data.newInterventionMethodLaw1 = '';
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>민사</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodLaw0"
                                                                        :checked="state.data.newInterventionMethodLaw0 === '형사'"
                                                                        @click="
                                                                            state.data.newInterventionMethodLaw0 = '형사';
                                                                            state.data.newInterventionMethodLaw1 = '';
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>형사</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodLaw0"
                                                                        :checked="state.data.newInterventionMethodLaw0 === '가사'"
                                                                        @click="
                                                                            state.data.newInterventionMethodLaw0 = '가사';
                                                                            state.data.newInterventionMethodLaw1 = '';
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>가사</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodLaw0"
                                                                        :checked="state.data.newInterventionMethodLaw0 === '행정'"
                                                                        @click="
                                                                            state.data.newInterventionMethodLaw0 = '행정';
                                                                            state.data.newInterventionMethodLaw1 = '';
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>행정</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="form_list"
                                                        v-if="
                                                            state.data.newInterventionMethod === '수사지원' ||
                                                            state.data.newInterventionMethod === '소송지원'
                                                        "
                                                    >
                                                        <div>
                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodLaw1"
                                                                        :checked="state.data.newInterventionMethodLaw1 === '기소'"
                                                                        @click="state.data.newInterventionMethodLaw1 = '기소'"
                                                                        :disabled="
                                                                            (state.mode === false && state.hasAuth !== 1) ||
                                                                            (state.data.newInterventionMethod === '소송지원' &&
                                                                                state.data.newInterventionMethodLaw0 !== '형사')
                                                                        "
                                                                    />
                                                                    <em></em>
                                                                    <span>기소</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodLaw1"
                                                                        :checked="state.data.newInterventionMethodLaw1 === '피소'"
                                                                        @click="state.data.newInterventionMethodLaw1 = '피소'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>피소</span>
                                                                </label>
                                                                <div v-if="state.data.newInterventionMethod === '소송지원'">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw1"
                                                                            :checked="state.data.newInterventionMethodLaw1 === '제소'"
                                                                            @click="state.data.newInterventionMethodLaw1 = '제소'"
                                                                            :disabled="
                                                                                (state.mode === false && state.hasAuth !== 1) ||
                                                                                (state.data.newInterventionMethod === '소송지원' &&
                                                                                    state.data.newInterventionMethodLaw0 === '형사')
                                                                            "
                                                                        />
                                                                        <em></em>
                                                                        <span>제소</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="form_list"
                                                        v-if="
                                                            state.data.newInterventionMethod === '수사지원' ||
                                                            state.data.newInterventionMethod === '소송지원'
                                                        "
                                                    >
                                                        <div class="flex wrap">
                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodLaw2"
                                                                        :checked="state.data.newInterventionMethodLaw2 === '선임'"
                                                                        @click="state.data.newInterventionMethodLaw2 = '선임'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>선임</span>
                                                                </label>
                                                            </div>

                                                            <div v-if="state.data.newInterventionMethodLaw2 === '선임'">
                                                                <input
                                                                    type="text"
                                                                    placeholder="기관명"
                                                                    v-model="state.data.newInterventionMethodLaw2Cop"
                                                                />
                                                            </div>

                                                            <div v-if="state.data.newInterventionMethodLaw2 === '선임'">
                                                                <input
                                                                    type="text"
                                                                    placeholder="변호인"
                                                                    v-model="state.data.newInterventionMethodLaw2Name"
                                                                />
                                                            </div>

                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodLaw2"
                                                                        :checked="state.data.newInterventionMethodLaw2 === '재판동행'"
                                                                        @click="state.data.newInterventionMethodLaw2 = '재판동행'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>재판동행</span>
                                                                </label>
                                                            </div>

                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodLaw2"
                                                                        :checked="state.data.newInterventionMethodLaw2 === '서면'"
                                                                        @click="state.data.newInterventionMethodLaw2 = '서면'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>서면</span>
                                                                </label>
                                                            </div>

                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodLaw2"
                                                                        :checked="state.data.newInterventionMethodLaw2 === '상담'"
                                                                        @click="state.data.newInterventionMethodLaw2 = '상담'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>상담</span>
                                                                </label>
                                                            </div>

                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodLaw2"
                                                                        :checked="state.data.newInterventionMethodLaw2 === '증거수집'"
                                                                        @click="state.data.newInterventionMethodLaw2 = '증거수집'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>증거수집</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="form_list"
                                                        v-if="
                                                            state.data.newInterventionMethod === '소송지원' &&
                                                            (state.data.newInterventionMethodLaw0 === '민사' ||
                                                                state.data.newInterventionMethodLaw0 === '형사')
                                                        "
                                                    >
                                                        <div class="flex wrap">
                                                            <template v-if="state.data.newInterventionMethodLaw0 === '민사'">
                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '손해배상'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '손해배상'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>손해배상</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '채무부존재'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '채무부존재'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>채무부존재</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '청구이의'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '청구이의'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>청구이의</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '개인파산면책'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '개인파산면책'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>개인파산면책</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '부당이익'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '부당이익'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>부당이익</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '대여금'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '대여금'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>대여금</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '기타'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '기타'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>기타</span>
                                                                    </label>
                                                                </div>
                                                            </template>

                                                            <template v-else-if="state.data.newInterventionMethodLaw0 === '형사'">
                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '성매매'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '성매매'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>성매매</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '사기'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '사기'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>사기</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '성폭행/상해'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '성폭행/상해'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>성폭행/상해</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '주거침입'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '주거침입'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>주거침입</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '명예훼손'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '명예훼손'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>명예훼손</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '협박'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '협박'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>협박</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '아청법'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '아청법'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>아청법</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '디지털성범죄'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '디지털성범죄'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>디지털성범죄</span>
                                                                    </label>
                                                                </div>

                                                                <div class="radio_wrap">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="newInterventionMethodLaw3"
                                                                            :checked="state.data.newInterventionMethodLaw3 === '기타'"
                                                                            @click="state.data.newInterventionMethodLaw3 = '기타'"
                                                                            :disabled="state.mode === false && state.hasAuth !== 1"
                                                                        />
                                                                        <em></em>
                                                                        <span>기타</span>
                                                                        <div v-if="state.data.newInterventionMethodLaw3 === '기타'">
                                                                            <input type="text" v-model="state.data.newInterventionMethodLaw3Txt" />
                                                                        </div>
                                                                    </label>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" v-if="state.data.result === '의료지원'">
                                        <div class="area_col_head"><label>의료지원</label></div>

                                        <div class="area_col_body no_padding">
                                            <div class="area_col_row">
                                                <div class="form_list_wrap">
                                                    <div class="form_list">
                                                        <label>[양방]</label>
                                                        <div class="flex wrap">
                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '정신과'"
                                                                        @click="state.data.newInterventionMethod = '정신과'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>정신건강의학</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '산부인과'"
                                                                        @click="state.data.newInterventionMethod = '산부인과'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>산부인과</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '내과'"
                                                                        @click="state.data.newInterventionMethod = '내과'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>내과</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '치과'"
                                                                        @click="state.data.newInterventionMethod = '치과'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>치과</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '외과'"
                                                                        @click="state.data.newInterventionMethod = '외과'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>외과</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '피부과'"
                                                                        @click="state.data.newInterventionMethod = '피부과'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>피부과</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="
                                                                            state.data.newInterventionMethod.includes('안과') ||
                                                                            state.data.newInterventionMethod.includes('이비인후과')
                                                                        "
                                                                        @click="state.data.newInterventionMethod = '안과/이비인후과'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>안과/이비인후과</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '비뇨기과'"
                                                                        @click="state.data.newInterventionMethod = '비뇨기과'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>비교기과</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '종합건강검진'"
                                                                        @click="state.data.newInterventionMethod = '종합건강검진'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>건강검진</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '개입방법/의료지원/기타'"
                                                                        @click="state.data.newInterventionMethod = '개입방법/의료지원/기타'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>기타</span>
                                                                    <div v-if="state.data.newInterventionMethod === '개입방법/의료지원/기타'">
                                                                        <input type="text" v-model="state.data.newInterventionMethodTxt1" />
                                                                    </div>
                                                                </label>
                                                            </div>

                                                            <div
                                                                v-if="
                                                                    state.data.newInterventionMethod !== '한방' &&
                                                                    state.data.newInterventionMethod !== '건강상담'
                                                                "
                                                            >
                                                                <div>
                                                                    <div class="flex ac">
                                                                        <div>
                                                                            <input
                                                                                type="text"
                                                                                placeholder="병원명"
                                                                                v-model="state.data.newInterventionMethodMedicalCop"
                                                                            />
                                                                        </div>

                                                                        <div>
                                                                            <input
                                                                                type="text"
                                                                                placeholder="주치의"
                                                                                v-model="state.data.newInterventionMethodMedicalName"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="form_list" v-if="state.data.newInterventionMethod === '개입방법/의료지원/기타'">
                                                        <div class="flex wrap">
                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodTxt1"
                                                                        :checked="state.data.newInterventionMethodTxt1 === '재활의학과'"
                                                                        @click="state.data.newInterventionMethodTxt1 = '재활의학과'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>재활의학과</span>
                                                                </label>
                                                            </div>

                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodTxt1"
                                                                        :checked="state.data.newInterventionMethodTxt1 === '영상의학과'"
                                                                        @click="state.data.newInterventionMethodTxt1 = '영상의학과'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>영상의학과</span>
                                                                </label>
                                                            </div>

                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodTxt1"
                                                                        :checked="state.data.newInterventionMethodTxt1 === '마취통증의학과'"
                                                                        @click="state.data.newInterventionMethodTxt1 = '마취통증의학과'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>마취통증의학과</span>
                                                                </label>
                                                            </div>

                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodTxt1"
                                                                        :checked="state.data.newInterventionMethodTxt1 === '수면의학과'"
                                                                        @click="state.data.newInterventionMethodTxt1 = '수면의학과'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>수면의학과</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="form_list">
                                                        <label>[한방]</label>
                                                        <div class="flex wrap">
                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '한방'"
                                                                        @click="state.data.newInterventionMethod = '한방'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>한방</span>
                                                                </label>
                                                            </div>

                                                            <div v-if="state.data.newInterventionMethod === '한방'">
                                                                <input
                                                                    type="text"
                                                                    placeholder="병원명"
                                                                    v-model="state.data.newInterventionMethodMedicalCop"
                                                                />
                                                            </div>

                                                            <div v-if="state.data.newInterventionMethod === '한방'">
                                                                <input
                                                                    type="text"
                                                                    placeholder="주치의"
                                                                    v-model="state.data.newInterventionMethodMedicalName"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="form_list">
                                                        <label>[건강상담]</label>
                                                        <div class="flex wrap">
                                                            <div class="radio_wrap">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '건강상담'"
                                                                        @click="state.data.newInterventionMethod = '건강상담'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>건강상담</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" v-if="state.data.result === '정서적지원'">
                                        <div class="area_col_head"><label>서비스/ 자원제공</label></div>

                                        <div class="area_col_body no_padding">
                                            <div class="area_col_row">
                                                <div class="form_list_wrap">
                                                    <div class="form_list">
                                                        <label>[정서지원]</label>
                                                        <div>
                                                            <div class="radio_wrap grid">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '일상생활상담'"
                                                                        @click="state.data.newInterventionMethod = '일상생활상담'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>일상생활상담</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '가족문제상담'"
                                                                        @click="state.data.newInterventionMethod = '가족문제상담'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>가족문제상담</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '경제문제상담'"
                                                                        @click="state.data.newInterventionMethod = '경제문제상담'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>경제문제상담</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '정보제공'"
                                                                        @click="state.data.newInterventionMethod = '정보제공'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>정보제공</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '타기관 상담의뢰'"
                                                                        @click="state.data.newInterventionMethod = '타기관 상담의뢰'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>타기관 상담의뢰</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '사부작공방 관련'"
                                                                        @click="state.data.newInterventionMethod = '사부작공방 관련'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>사부작공방관련</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="form_list"
                                                        v-if="
                                                            state.data.newInterventionMethod === '정보제공' ||
                                                            state.data.newInterventionMethod === '타기관 상담의뢰'
                                                        "
                                                    >
                                                        <label>[의뢰기관]</label>
                                                        <div>
                                                            <div class="radio_wrap grid">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodEmotionOtherInstitutions"
                                                                        :checked="
                                                                            state.data.newInterventionMethodEmotionOtherInstitutions ===
                                                                            '경찰·검찰·법원'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethodEmotionOtherInstitutions =
                                                                                '경찰·검찰·법원'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>경찰·검찰·법원</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodEmotionOtherInstitutions"
                                                                        :checked="
                                                                            state.data.newInterventionMethodEmotionOtherInstitutions ===
                                                                            '성매매방지기관'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethodEmotionOtherInstitutions =
                                                                                '성매매방지기관'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>성매매방지기관</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodEmotionOtherInstitutions"
                                                                        :checked="
                                                                            state.data.newInterventionMethodEmotionOtherInstitutions ===
                                                                            '전문상담기관'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethodEmotionOtherInstitutions = '전문상담기관'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>전문상담기관</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodEmotionOtherInstitutions"
                                                                        :checked="
                                                                            state.data.newInterventionMethodEmotionOtherInstitutions ===
                                                                            '직업훈련·알선기관'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethodEmotionOtherInstitutions =
                                                                                '직업훈련·알선기관'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>직업훈련·알선기관</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodEmotionOtherInstitutions"
                                                                        :checked="
                                                                            state.data.newInterventionMethodEmotionOtherInstitutions ===
                                                                            '1366·1388 등'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethodEmotionOtherInstitutions = '1366·1388 등'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>1366·1388 등</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodEmotionOtherInstitutions"
                                                                        :checked="
                                                                            state.data.newInterventionMethodEmotionOtherInstitutions ===
                                                                            '학교·대안교육기관'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethodEmotionOtherInstitutions =
                                                                                '학교·대안교육기관'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>학교·대안교육기관</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodEmotionOtherInstitutions"
                                                                        :checked="state.data.newInterventionMethodEmotionOtherInstitutions === '기타'"
                                                                        @click="state.data.newInterventionMethodEmotionOtherInstitutions = '기타'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>기타</span>
                                                                </label>
                                                            </div>
                                                            <div style="margin-top: 10px">
                                                                <div
                                                                    v-if="
                                                                        (state.data.newInterventionMethod === '정보제공' ||
                                                                            state.data.newInterventionMethod === '타기관 상담의뢰') &&
                                                                        state.data.newInterventionMethodEmotionOtherInstitutions !== ''
                                                                    "
                                                                >
                                                                    <input
                                                                        tyep="text"
                                                                        v-model="state.data.newInterventionMethodEmotionOtherInstitutionsDesc"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col" v-if="state.data.result === '자활지원'">
                                        <div class="area_col_head"><label>서비스/ 자원제공</label></div>

                                        <div class="area_col_body no_padding">
                                            <div class="area_col_row">
                                                <div class="form_list_wrap">
                                                    <div class="form_list">
                                                        <label>[자활지원]</label>
                                                        <div>
                                                            <div class="radio_wrap grid">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '자활상담/정보제공/지원'"
                                                                        @click="state.data.newInterventionMethod = '자활상담/정보제공/지원'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>자활상담/정보제공/지원</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '주거상담/정보제공/지원'"
                                                                        @click="state.data.newInterventionMethod = '주거상담/정보제공/지원'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>주거상담/정보제공/지원</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '자활관련기초검사'"
                                                                        @click="state.data.newInterventionMethod = '자활관련기초검사'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>자활관련기초검사</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '직업훈련수당'"
                                                                        @click="state.data.newInterventionMethod = '직업훈련수당'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>직업훈련수당</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="
                                                                            state.data.newInterventionMethod ===
                                                                            '개입방법/서비스자원제공/자활지원/기타'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethod = '개입방법/서비스자원제공/자활지원/기타'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>기타</span>
                                                                </label>
                                                            </div>

                                                            <!-- <div>
                                                                <input type="text" placeholder="" />
                                                            </div> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col" v-if="state.data.result === '집단프로그램'">
                                        <div class="area_col_head"><label>서비스/ 자원제공</label></div>

                                        <div class="area_col_body no_padding">
                                            <div class="area_col_row">
                                                <div class="form_list_wrap">
                                                    <div class="form_list">
                                                        <label>[집단프로그램]</label>
                                                        <div>
                                                            <div class="radio_wrap grid">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '심리정서프로그램'"
                                                                        @click="state.data.newInterventionMethod = '심리정서프로그램'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>심리정서프로그램</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '사각지대 프로그램'"
                                                                        @click="state.data.newInterventionMethod = '사각지대 프로그램'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>사각지대프로그램</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '사회적응프로그램'"
                                                                        @click="state.data.newInterventionMethod = '사회적응프로그램'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>사회적응프로그램</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '문화/체험활동'"
                                                                        @click="state.data.newInterventionMethod = '문화/체험활동'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>문화/체험활동</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '건강관리/체력강화'"
                                                                        @click="state.data.newInterventionMethod = '건강관리/체력강화'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>건강관리/체력강화</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="
                                                                            state.data.newInterventionMethod ===
                                                                            '개입방법/서비스자원제공/집단프로그램/기타'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethod =
                                                                                '개입방법/서비스자원제공/집단프로그램/기타'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>기타</span>
                                                                    <div
                                                                        v-if="
                                                                            state.data.newInterventionMethod ===
                                                                            '개입방법/서비스자원제공/집단프로그램/기타'
                                                                        "
                                                                    >
                                                                        <input
                                                                            type="text"
                                                                            placeholder=""
                                                                            v-model="state.data.newInterventionMethodTxt2"
                                                                        />
                                                                    </div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form_list" v-if="state.data.newInterventionMethod === '사각지대 프로그램'">
                                                    <label>[사각지대프로그램]</label>
                                                    <div>
                                                        <div class="radio_wrap grid">
                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    name="newInterventionMethodGroupProgram"
                                                                    :checked="state.data.newInterventionMethodGroupProgram === '사부작공방'"
                                                                    @click="state.data.newInterventionMethodGroupProgram = '사부작공방'"
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>사부작공방</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    name="newInterventionMethodGroupProgram"
                                                                    :checked="state.data.newInterventionMethodGroupProgram === '사회적응력향상'"
                                                                    @click="state.data.newInterventionMethodGroupProgram = '사회적응력향상'"
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>사회적응력향상</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="radio"
                                                                    name="newInterventionMethodGroupProgram"
                                                                    :checked="state.data.newInterventionMethodGroupProgram === '동료활동'"
                                                                    @click="state.data.newInterventionMethodGroupProgram = '동료활동'"
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>동료활동</span>
                                                                <div>
                                                                    <input type="text" v-model="state.data.newInterventionMethodGroupProgramDesc" />
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col" v-if="state.data.result === '물적자원'">
                                        <div class="area_col_head"><label>서비스/ 자원제공</label></div>

                                        <div class="area_col_body no_padding">
                                            <div class="area_col_row">
                                                <div class="form_list_wrap">
                                                    <div class="form_list">
                                                        <label>[물적자원]</label>
                                                        <div>
                                                            <div class="radio_wrap grid">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="
                                                                            state.data.newInterventionMethod ===
                                                                            '개입방법/서비스자원제공/물적지원/물품'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethod = '개입방법/서비스자원제공/물적지원/물품'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>물품</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="
                                                                            state.data.newInterventionMethod ===
                                                                            '개입방법/서비스자원제공/물적지원/후원금'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethod =
                                                                                '개입방법/서비스자원제공/물적지원/후원금'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>후원금</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="area_col" v-if="state.data.result === '물적자원'">
                                        <div class="area_col_head"><label>서비스/ 자원연결</label></div>

                                        <div class="area_col_body no_padding">
                                            <div class="area_col_row">
                                                <div class="form_list_wrap">
                                                    <div class="form_list">
                                                        <label>[물적자원]</label>
                                                        <div>
                                                            <div class="radio_wrap grid">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="
                                                                            state.data.newInterventionMethod === '개입방법/서비스연결/물적직원/물품'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethod = '개입방법/서비스연결/물적직원/물품'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>물품</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="
                                                                            state.data.newInterventionMethod === '개입방법/서비스연결/물적직원/후원금'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethod = '개입방법/서비스연결/물적직원/후원금'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>후원금</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" v-if="state.data.result === '심리지원'">
                                        <div class="area_col_head"><label>서비스/ 자원연결</label></div>

                                        <div class="area_col_body no_padding">
                                            <div class="area_col_row">
                                                <div class="form_list_wrap">
                                                    <div class="form_list">
                                                        <label>[심리지원]</label>
                                                        <div class="flex wrap">
                                                            <div class="radio_wrap grid">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '개별상담'"
                                                                        @click="state.data.newInterventionMethod = '개별상담'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>개별상담</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '집단상담'"
                                                                        @click="state.data.newInterventionMethod = '집단상담'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>집단상담</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '임상심리검사'"
                                                                        @click="state.data.newInterventionMethod = '임상심리검사'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>임상심리검사</span>
                                                                </label>
                                                            </div>

                                                            <div class="flex ac">
                                                                <div>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="기관명"
                                                                        v-model="state.data.newInterventionMethodPsychologyCop"
                                                                    />
                                                                </div>

                                                                <div>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="상담사"
                                                                        v-model="state.data.newInterventionMethodPsychologyName"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" v-if="state.data.result === '관련기관연계'">
                                        <div class="area_col_head"><label>타기관의뢰</label></div>

                                        <div class="area_col_body no_padding">
                                            <div class="area_col_row">
                                                <div class="form_list_wrap">
                                                    <div class="form_list">
                                                        <label>[기관유형]</label>
                                                        <div>
                                                            <div class="radio_wrap grid">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '타(성매매)상담소'"
                                                                        @click="state.data.newInterventionMethod = '타(성매매)상담소'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>타(성매매)상담소</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '지원시설'"
                                                                        @click="state.data.newInterventionMethod = '지원시설'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>지원시설</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '공동생활가정'"
                                                                        @click="state.data.newInterventionMethod = '공동생활가정'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>공동생활가정</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '자활지원센터'"
                                                                        @click="state.data.newInterventionMethod = '자활지원센터'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>자활지원센터</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '직업훈련기관'"
                                                                        @click="state.data.newInterventionMethod = '직업훈련기관'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>직업훈련 알선기관</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="
                                                                            state.data.newInterventionMethod === '전문상담기관(성폭·가폭·장애인)'
                                                                        "
                                                                        @click="state.data.newInterventionMethod = '전문상담기관(성폭·가폭·장애인)'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>전문상담기관 (성폭·가폭·장애인 등)</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '대안교육위탁기관'"
                                                                        @click="state.data.newInterventionMethod = '대안교육위탁기관'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>대안교육위탁기관</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '일시쉼터'"
                                                                        @click="state.data.newInterventionMethod = '일시쉼터'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>일시쉼터</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="
                                                                            state.data.newInterventionMethod === '개입방법/타기관의뢰/기관유형/기타'
                                                                        "
                                                                        @click="
                                                                            state.data.newInterventionMethod = '개입방법/타기관의뢰/기관유형/기타'
                                                                        "
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>기타</span>
                                                                    <div
                                                                        class=""
                                                                        v-if="
                                                                            state.data.newInterventionMethod === '개입방법/타기관의뢰/기관유형/기타'
                                                                        "
                                                                    >
                                                                        <input type="text" v-model="state.data.newInterventionMethodOtherTxt" />
                                                                    </div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="form_list"
                                                        v-if="state.data.newInterventionMethod === '전문상담기관(성폭·가폭·장애인)'"
                                                    >
                                                        <label>[전문상담기관]</label>
                                                        <div>
                                                            <div class="radio_wrap grid">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodProfessional"
                                                                        :checked="state.data.newInterventionMethodProfessional === '성폭력'"
                                                                        @click="state.data.newInterventionMethodProfessional = '성폭력'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>성폭력</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodProfessional"
                                                                        :checked="state.data.newInterventionMethodProfessional === '가정폭력'"
                                                                        @click="state.data.newInterventionMethodProfessional = '가정폭력'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>가정폭력</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodProfessional"
                                                                        :checked="state.data.newInterventionMethodProfessional === '장애인'"
                                                                        @click="state.data.newInterventionMethodProfessional = '장애인'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>장애인</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodProfessional"
                                                                        :checked="state.data.newInterventionMethodProfessional === '이주여성'"
                                                                        @click="state.data.newInterventionMethodProfessional = '이주여성'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>이주여성</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodProfessional"
                                                                        :checked="state.data.newInterventionMethodProfessional === '디지털성범죄'"
                                                                        @click="state.data.newInterventionMethodProfessional = '디지털성범죄'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>디지털성범죄</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="form_list">
                                                        <label>[상담유형]</label>
                                                        <div>
                                                            <div class="radio_wrap grid">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodOtherAdviceType"
                                                                        :checked="state.data.newInterventionMethodOtherAdviceType === '의뢰상담'"
                                                                        @click="state.data.newInterventionMethodOtherAdviceType = '의뢰상담'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>의뢰상담</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodOtherAdviceType"
                                                                        :checked="state.data.newInterventionMethodOtherAdviceType === '모니터링 상담'"
                                                                        @click="state.data.newInterventionMethodOtherAdviceType = '모니터링 상담'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>모니터링 상담</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodOtherAdviceType"
                                                                        :checked="state.data.newInterventionMethodOtherAdviceType === '입소'"
                                                                        @click="state.data.newInterventionMethodOtherAdviceType = '입소'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>입소</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethodOtherAdviceType"
                                                                        :checked="state.data.newInterventionMethodOtherAdviceType === '이용자등록'"
                                                                        @click="state.data.newInterventionMethodOtherAdviceType = '이용자등록'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>이용자 등록</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col no-line-bottom" v-if="state.data.result === '기타'">
                                        <div class="area_col_head"><label>기타</label></div>

                                        <div class="area_col_body no_padding">
                                            <div class="area_col_row">
                                                <div class="form_list_wrap">
                                                    <div class="form_list">
                                                        <label>[기타]</label>
                                                        <div>
                                                            <div class="radio_wrap grid">
                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '무응답'"
                                                                        @click="state.data.newInterventionMethod = '무응답'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>무응답</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '연락두절'"
                                                                        @click="state.data.newInterventionMethod = '연락두절'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>연락두절</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '통화거절'"
                                                                        @click="state.data.newInterventionMethod = '통화거절'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>통화거절</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '행정'"
                                                                        @click="state.data.newInterventionMethod = '행정'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>행정</span>
                                                                </label>

                                                                <label>
                                                                    <input
                                                                        type="radio"
                                                                        name="newInterventionMethod"
                                                                        :checked="state.data.newInterventionMethod === '종결'"
                                                                        @click="state.data.newInterventionMethod = '종결'"
                                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                                    />
                                                                    <em></em>
                                                                    <span>종결</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row page_avoid">
                                <div class="area_col_head"><label>8. 성과현황</label></div>
                                <div class="area_col_row">
                                    <div class="area_col">
                                        <div class="area_col_body">
                                            <div class="checkbox_wrap">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newSuccessState === 1"
                                                        @click="state.data.newSuccessState ^= 1"
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>※ 성과 현황 입력시 체크 바랍니다.</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col">
                                        <div class="area_col_head"><label>[의료지원]</label></div>
                                        <div class="area_col_body">
                                            <div class="checkbox_wrap">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newSuccessMonthMedicalTreatmentStop === '치료중단'"
                                                        @click="
                                                            state.data.newSuccessMonthMedicalTreatmentStop =
                                                                state.data.newSuccessMonthMedicalTreatmentStop === '치료중단' ? '' : '치료중단'
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>치료중단</span>
                                                </label>
                                            </div>

                                            <div class="checkbox_wrap">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newSuccessMonthMedicalTreatmentIng === '치료중'"
                                                        @click="
                                                            state.data.newSuccessMonthMedicalTreatmentIng =
                                                                state.data.newSuccessMonthMedicalTreatmentIng === '치료중' ? '' : '치료중'
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>치료중</span>
                                                </label>
                                            </div>

                                            <div class="checkbox_wrap">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newSuccessMonthMedicalTreatmentCompleteControl === '완치/증상조절'"
                                                        @click="
                                                            state.data.newSuccessMonthMedicalTreatmentCompleteControl =
                                                                state.data.newSuccessMonthMedicalTreatmentCompleteControl === '완치/증상조절'
                                                                    ? ''
                                                                    : '완치/증상조절'
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>완치/증상조절</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col">
                                        <div class="area_col_head"><label>[법률지원]</label></div>
                                        <div class="area_col_body">
                                            <div class="checkbox_wrap">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newSuccessMonthLawasWin === '승소'"
                                                        @click="
                                                            state.data.newSuccessMonthLawasWin =
                                                                state.data.newSuccessMonthLawasWin === '승소' ? '' : '승소'
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>승소</span>
                                                </label>
                                            </div>

                                            <div class="checkbox_wrap">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newSuccessMonthLawasLose === '패소'"
                                                        @click="
                                                            state.data.newSuccessMonthLawasLose =
                                                                state.data.newSuccessMonthLawasLose === '패소' ? '' : '패소'
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>패소</span>
                                                </label>
                                            </div>

                                            <div class="checkbox_wrap">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newSuccessMonthLawasProtective === '보호처분'"
                                                        @click="
                                                            state.data.newSuccessMonthLawasProtective =
                                                                state.data.newSuccessMonthLawasProtective === '보호처분' ? '' : '보호처분'
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>보호처분</span>
                                                </label>
                                            </div>

                                            <div class="checkbox_wrap">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newSuccessMonthLawasBankruptcyDishonestly === '파산/면책결정'"
                                                        @click="
                                                            state.data.newSuccessMonthLawasBankruptcyDishonestly =
                                                                state.data.newSuccessMonthLawasBankruptcyDishonestly === '파산/면책결정'
                                                                    ? ''
                                                                    : '파산/면책결정'
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>파산/면책결정</span>
                                                </label>
                                            </div>

                                            <div class="checkbox_wrap">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newSuccessMonthLawasMediation === '조정/합의'"
                                                        @click="
                                                            state.data.newSuccessMonthLawasMediation =
                                                                state.data.newSuccessMonthLawasMediation === '조정/합의' ? '' : '조정/합의'
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>조정/합의</span>
                                                </label>
                                            </div>

                                            <div class="checkbox_wrap">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        :checked="state.data.newSuccessMonthLawasDefer === '잠정보류'"
                                                        @click="
                                                            state.data.newSuccessMonthLawasDefer =
                                                                state.data.newSuccessMonthLawasDefer === '잠정보류' ? '' : '잠정보류'
                                                        "
                                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                                    />
                                                    <em></em>
                                                    <span>잠정보류</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col no-line-bottom">
                                        <div class="area_col_head"><label>[자활지원]</label></div>

                                        <div class="area_col_body no_padding">
                                            <div class="area_col_row">
                                                <div class="area_col">
                                                    <div class="area_col_head"><label>※취업 및 진학 현황</label></div>
                                                    <div class="area_col_body">
                                                        <div class="checkbox_wrap flex wrap">
                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    name="newSuccessMonthJawhalJobService"
                                                                    :checked="state.data.newSuccessMonthJawhalJobService === '서비스업'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalJobService =
                                                                            state.data.newSuccessMonthJawhalJobService === '서비스업'
                                                                                ? ''
                                                                                : '서비스업'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>서비스업</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    name="newSuccessMonthJawhalJobWorker"
                                                                    :checked="state.data.newSuccessMonthJawhalJobWorker === '생산직'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalJobWorker =
                                                                            state.data.newSuccessMonthJawhalJobWorker === '생산직' ? '' : '생산직'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>생산직</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalOfficejob === '사무직'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalOfficejob =
                                                                            state.data.newSuccessMonthJawhalOfficejob === '사무직' ? '' : '사무직'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>사무직</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalSuppasOwnbusi === '창업'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalSuppasOwnbusi =
                                                                            state.data.newSuccessMonthJawhalSuppasOwnbusi === '창업' ? '' : '창업'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>창업</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalSuppasUniv === '진학'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalSuppasUniv =
                                                                            state.data.newSuccessMonthJawhalSuppasUniv === '진학' ? '' : '진학'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>진학</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalSuppasCerti === '자격증취득'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalSuppasCerti =
                                                                            state.data.newSuccessMonthJawhalSuppasCerti === '자격증취득'
                                                                                ? ''
                                                                                : '자격증취득'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>자격증 취득</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="
                                                                        state.data.newSuccessMonthJawhalCertificateExamination === '검정고시합격'
                                                                    "
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalCertificateExamination =
                                                                            state.data.newSuccessMonthJawhalCertificateExamination === '검정고시합격'
                                                                                ? ''
                                                                                : '검정고시합격'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>검정고시 합격</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalHighdegreeGet === '상위학위취득'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalHighdegreeGet =
                                                                            state.data.newSuccessMonthJawhalHighdegreeGet === '상위학위취득'
                                                                                ? ''
                                                                                : '상위학위취득'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>상위학위 취득</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalRegisterSchool === '학원등록'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalRegisterSchool =
                                                                            state.data.newSuccessMonthJawhalRegisterSchool === '학원등록'
                                                                                ? ''
                                                                                : '학원등록'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>학원등록</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalLevelup === '진급'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalLevelup =
                                                                            state.data.newSuccessMonthJawhalLevelup === '진급' ? '' : '진급'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>진급</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalEtc === '기타'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalEtc =
                                                                            state.data.newSuccessMonthJawhalEtc === '기타' ? '' : '기타'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>기타</span>
                                                                <div v-if="state.data.newSuccessMonthJawhalEtc === '기타'">
                                                                    <input type="text" v-model="state.data.newSuccessMonthJawhalEtcTxt" />
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="area_col">
                                                    <div class="area_col_head"><label>※고용형태</label></div>
                                                    <div class="area_col_body">
                                                        <div class="checkbox_wrap flex wrap">
                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalJobRegular === '정규직'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalJobRegular =
                                                                            state.data.newSuccessMonthJawhalJobRegular === '정규직' ? '' : '정규직'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>정규직</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalJobNonRegular === '비정규직'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalJobNonRegular =
                                                                            state.data.newSuccessMonthJawhalJobNonRegular === '비정규직'
                                                                                ? ''
                                                                                : '비정규직'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>비정규직</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalJobIntern === '인턴,실습'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalJobIntern =
                                                                            state.data.newSuccessMonthJawhalJobIntern === '인턴,실습'
                                                                                ? ''
                                                                                : '인턴,실습'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>인턴,실습</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalJobDaily === '단기근로자'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalJobDaily =
                                                                            state.data.newSuccessMonthJawhalJobDaily === '단기근로자'
                                                                                ? ''
                                                                                : '단기근로자'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>단기근로자</span>
                                                            </label>

                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    :checked="state.data.newSuccessMonthJawhalJobEtc === '기타'"
                                                                    @click="
                                                                        state.data.newSuccessMonthJawhalJobEtc =
                                                                            state.data.newSuccessMonthJawhalJobEtc === '기타' ? '' : '기타'
                                                                    "
                                                                    :disabled="state.mode === false && state.hasAuth !== 1"
                                                                />
                                                                <em></em>
                                                                <span>기타</span>
                                                                <div v-if="state.data.newSuccessMonthJawhalJobEtc === '기타'">
                                                                    <input type="text" v-model="state.data.newSuccessMonthJawhalJobEtcTxt" />
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head">
                                    <label>
                                        9. 상담원 종합의견 /
                                        <br />
                                        추후 계획 /
                                        <br />
                                        논의요청
                                    </label>
                                </div>

                                <div class="area_col_body textarea_wrap">
                                    <textarea
                                        v-model="state.data.counselDetailVO.newCounselorDesc"
                                        :disabled="state.mode === false && state.hasAuth !== 1"
                                    ></textarea>
                                    <p v-text="state.data.counselDetailVO.newCounselorDesc"></p>
                                </div>
                            </div>

                            <div class="area_row noPrint">
                                <div class="area_col_head">
                                    <label>10. 슈퍼비전</label>
                                </div>

                                <div class="area_col_body textarea_wrap">
                                    <textarea v-model="state.data.counselDetailVO.opinion" :disabled="!CommonUtils.checkAuth()"></textarea>
                                    <p v-text="state.data.counselDetailVO.opinion"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="area_section">
                    <div class="area_form_foot">
                        <div class="area_button">
                            <button type="button" @click="router.push({ name: 'counselListForClient', params: { id: state.clientIdx } })">
                                내담자의 상담기록 리스트 가기
                            </button>
                            <button type="button" @click="router.push({ name: 'counsel' })">상담목록 가기</button>

                            <template v-if="state.mode">
                                <button type="button" class="active" @click="add()">등록</button>
                            </template>
                            <template v-else>
                                <template v-if="state.hasAuth === 1">
                                    <button type="button" class="active" @click="confirmModify">저장</button>
                                </template>
                                <button
                                    v-else-if="state.hasAuth === -1 || state.hasAuth === 3"
                                    type="button"
                                    class="active"
                                    @click="showRequestAccessModal(1)"
                                >
                                    수정 권한 요청
                                </button>
                                <button v-else-if="state.hasAuth === 0" type="button" class="gray" @click="">수정 승인 대기</button>
                                <template v-else-if="state.hasAuth === 2">
                                    <button type="button" class="active" @click="showRequestAccessModal(1)">수정 재승인 요청</button>
                                    <button type="button" class="blueBtn" @click="showRejectReason(state.modify.rejectReason)">반려 사유</button>
                                </template>
                                <template v-if="state.hasDeleteAuth === 1">
                                    <button type="button" class="danger" @click="confirmRemove()">삭제</button>
                                </template>
                                <button
                                    v-else-if="state.hasDeleteAuth === -1 || state.hasDeleteAuth === 3"
                                    type="button"
                                    class="danger"
                                    @click="showRequestAccessModal(2)"
                                >
                                    삭제 권한 요청
                                </button>
                                <button v-else-if="state.hasDeleteAuth === 0" type="button" class="gray" @click="">삭제 승인 대기</button>
                                <template v-else-if="state.hasDeleteAuth === 2">
                                    <button type="button" class="gray" @click="showRequestAccessModal(2)">삭제 재승인 요청</button>
                                    <button type="button" class="blueBtn" @click="showRejectReason(state.remove.rejectReason)">반려 사유</button>
                                </template>
                            </template>

                            <button type="button" class="active" v-if="!state.mode && CommonUtils.checkAuth()" @click="confirmModify2">승인</button>

                            <button type="button" class="active" v-if="!state.mode && CommonUtils.checkAuth()" @click="confirmModify3">보완</button>

                            <button type="button" @click="reset">다시작성</button>

                            <button type="button" @click="anotherDetail(0)" v-if="state.hasPrev">이전</button>
                            <button type="button" @click="anotherDetail(1)" v-if="state.hasNext">다음</button>

                            <button type="button" @click="addForTemporary" v-if="state.mode">임시저장</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        :gubun="state.gubun"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        DataGrid,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        ClientDetail,
        types,
        CommonUtils,
        CommonOptions,
        useRoute,
        CommonForms,
        getMessageByCode,
        ref,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, ClientDetail },
        setup() {
            const route = useRoute();
            const user = userStore();
            const today = new Date();

            const state = reactive({
                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                gubun: 1 as 1 | 2 | 3 | 4,

                clientIdx: 0 as number,
                counselIdx: 0 as number,
                mode: true as boolean, // true: insert, false: update
                hasAuth: -1 as -1 | 0 | 1 | 2 | 3 | 4, // 0: 대기, 1: 승인, 2: 반려, 3: 수정완료, 4: 처리완료
                hasDeleteAuth: -1 as -1 | 0 | 1 | 2 | 3 | 4, // 0: 대기, 1: 승인, 2: 반려, 3: 수정완료, 4: 처리완료

                modify: {} as any,
                remove: {} as any,

                hasPrev: false as boolean,
                hasNext: false as boolean,

                data: {
                    counselDetailVO: {} as any,
                    clientVO: {} as any,
                    prev: {} as any,
                    next: {} as any,
                } as types.counsel.CounselVO | any,
            });

            const prevDate = ref();

            onMounted(async () => {
                state.clientIdx = Number(route.params.id);

                state.hasPrev = false;
                state.hasNext = false;

                if (route.params.idx) {
                    state.counselIdx = Number(route.params.idx);
                    state.mode = false;

                    await detail();

                    if (state.data && state.data.date) {
                        if (state.data.state !== 1 || CommonUtils.checkAuth() || (user.userInfo.auth === 5 && state.data.dept === 4)) {
                            state.hasAuth = 1;
                            state.hasDeleteAuth = 1;
                        } else if (state.data.state === 1) {
                            state.hasAuth = -1;
                            state.hasDeleteAuth = -1;

                            getAccessRequestForTarget();
                        }
                    }
                } else {
                    state.mode = true;

                    state.data = {
                        counselDetailVO: {} as any,
                        clientVO: {} as any,
                        csmName: user.userInfo.name as string,
                        date: CommonUtils.getToday(""),
                    } as types.counsel.CounselVO;
                }
            });

            watch(
                () => route.params,
                async () => {
                    state.hasPrev = false;
                    state.hasNext = false;

                    state.clientIdx = Number(route.params.id);
                    if (route.params.idx) {
                        state.counselIdx = Number(route.params.idx);
                        state.mode = false;

                        await detail();

                        if (state.data && state.data.date) {
                            if (state.data.state !== 1 || CommonUtils.checkAuth() || (user.userInfo.auth === 5 && state.data.dept === 4)) {
                                state.hasAuth = 1;
                                state.hasDeleteAuth = 1;
                            } else if (state.data.state === 1) {
                                state.hasAuth = -1;
                                state.hasDeleteAuth = -1;

                                getAccessRequestForTarget();
                            }
                        }
                    } else {
                        state.counselIdx = 0;
                        state.mode = true;

                        state.data = {
                            counselDetailVO: {} as any,
                            clientVO: {} as any,
                            csmName: user.userInfo.name as string,
                            date: CommonUtils.getToday(""),
                        } as types.counsel.CounselVO;
                    }
                },
            );

            const reset = () => {
                if (state.counselIdx) detail();
                else
                    state.data = {
                        counselDetailVO: {} as any,
                        clientVO: {} as any,
                    };
            };

            const setDateToToday = () => {
                state.data.date = today.toLocaleDateString("sv-SE");
            };

            const onChangeDate = (e: any) => {
                const newDate = e.target.value;

                state.data.date = newDate;
                prevDate.value = newDate;
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "requestAccess") {
                    requestAccess(param.gubun, param.content);
                } else if (param.action === "confirm") {
                    switch (param.gubun) {
                        case 1:
                            modify(param.path);
                            break;
                        case 2:
                            remove();
                            break;
                        case 3:
                            confirmByTeamLeader(1);
                            break;
                        case 4:
                            confirmByTeamLeader(2, param.content);
                            break;
                    }
                } else if (param.action === "callback") {
                    if (param.gubun === 1) {
                        state.isShowModal = false;
                        detail();
                    } else if (param.gubun === 2) {
                        router.replace({ name: "counselListForClient", params: { id: state.clientIdx } });
                    } else if (param.gubun === 3) {
                        router.replace({ name: "temporary" });
                    } else {
                        state.isShowModal = false;
                    }
                }
            };

            const detail = async () => {
                const res: types.counsel.ResCounsel = await apiService.counsel.detail(state.counselIdx);

                if (res.returnCode === 0) {
                    state.data = res.data;
                    state.data.date = CommonUtils.dateFormatYYYYMMDD(state.data.date, "-");

                    if (res.prev) {
                        state.hasPrev = true;
                        state.data.prev = res.prev;
                    }
                    if (res.next) {
                        state.hasNext = true;
                        state.data.next = res.next;
                    }
                } else {
                    state.data = null;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getAccessRequestForTarget = async () => {
                const res: types.accessRequest.ResAccessRequestForTarget = await apiService.accessRequest.detailForTarget(
                    2,
                    Number(route.params.idx),
                );
                if (res.returnCode === 0) {
                    const modify = res.modify;
                    if (modify && modify.state > -1) {
                        state.hasAuth = modify.state;
                        state.modify = modify;
                    }

                    const remove = res.remove;
                    if (remove && remove.state > -1) {
                        state.hasDeleteAuth = remove.state;
                        state.remove = remove;
                    }
                } else {
                    state.hasAuth = -1;
                    state.hasDeleteAuth = -1;
                }
            };

            const showRequestAccessModal = (gubun: 1 | 2) => {
                state.modalTab = 2;
                state.modalTitle = gubun === 1 ? "수정 권한 요청" : "삭제 권한 요청";
                state.isShowModal = true;
                state.gubun = gubun;
            };

            const requestAccess = async (gubun: 1 | 2, reason: string) => {
                const param: types.accessRequest.ReqAccessRequest = {
                    type: 2,
                    gubun: gubun,
                    targetIdx: state.data.coIdx,
                    reason: reason,
                };
                const res = await apiService.accessRequest.add(param);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "권한을 요청하였습니다. <br> 관리자 승인 후, 가능합니다.";
                    state.isShowModal = true;

                    getAccessRequestForTarget();
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const confirmModify = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 변경하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 1;
            };

            const confirmRemove = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 2;
            };

            const confirmModify2 = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 승인하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 3;
            };

            const confirmModify3 = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 보완하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 4;
            };

            const add = async () => {
                if (await checkRequiredValue()) {
                    const param: types.counsel.ReqCounsel = state.data;

                    param.newPrevSupportingExpensePrice =
                        Number(state.data.newPrevMedicalPrice) +
                        Number(state.data.newPrevLawPrice) +
                        Number(state.data.newPrevJobTrainingPrice) +
                        Number(state.data.newPrevNotGraspPrice);

                    Object.assign(param, state.data.counselDetailVO);

                    param.date = param.date.replaceAll("-", "");
                    const res = await apiService.counsel.add(state.clientIdx, param);
                    if (res.returnCode === 0) {
                        state.modalTab = 3;
                        state.modalTitle = "알림";
                        state.modalContent = "등록되었습니다.";
                        state.isShowModal = true;
                        state.gubun = 2;
                    } else {
                        console.error(res.description);
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const modify = async (path?: string) => {
                if (await checkRequiredValue()) {
                    const param: types.counsel.ReqCounselForModify = state.data;
                    param.newPrevSupportingExpensePrice =
                        Number(state.data.newPrevMedicalPrice) +
                        Number(state.data.newPrevLawPrice) +
                        Number(state.data.newPrevJobTrainingPrice) +
                        Number(state.data.newPrevNotGraspPrice);

                    Object.assign(param, state.data.counselDetailVO);

                    param.date = param.date!.replaceAll("-", "");
                    const res = await apiService.counsel.modify(Number(route.params.idx), param);
                    if (res.returnCode === 0) {
                        state.modalTab = 3;
                        state.modalTitle = "알림";
                        state.modalContent = "수정되었습니다.";
                        state.isShowModal = true;
                        state.gubun = 1;
                    } else {
                        console.error(res.description);
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const remove = async () => {
                const res = await apiService.counsel.remove(state.counselIdx);
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제되었습니다.";
                    state.isShowModal = true;
                    state.gubun = 2;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const confirmByTeamLeader = async (numState: number, content?: string) => {
                const comment = content ? content : "";
                const res = await apiService.counsel.confirm(state.counselIdx, state.data.counselDetailVO.opinion, comment, numState);
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "저장되었습니다.";
                    state.isShowModal = true;
                    state.gubun = 1;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const showRejectReason = (reason: string) => {
                state.modalTab = -1;
                state.modalTitle = "반려 사유";
                state.modalContent = reason.replaceAll("\n", "<br>");
                state.isShowModal = true;
            };

            const checkRequiredValue = async () => {
                if (!state.data.result) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "지원구분을 입력해주세요.";
                    state.isShowModal = true;
                    return false;
                } else if (!state.data.newInterventionMethod) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "개입방법을 입력해주세요.";
                    state.isShowModal = true;
                    return false;
                } else if (!state.data.date) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "작성일을 입력해주세요.";
                    state.isShowModal = true;
                    return false;
                } else if (!state.data.csmName) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "작성자를 입력해주세요.";
                    state.isShowModal = true;
                    return false;
                } else if (!state.data.cstype) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "상담유형을 입력해주세요.";
                    state.isShowModal = true;
                    return false;
                } else if (!state.data.csperson) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "상담 대상자를 입력해주세요.";
                    state.isShowModal = true;
                    return false;
                } else if (!state.data.title) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "상담 제목을 입력해주세요.";
                    state.isShowModal = true;
                    return false;
                }
                return true;
            };

            const anotherDetail = (gubun: 0 | 1 = 0) => {
                let idx = 0;
                let data = null;
                if (gubun === 0 && state.hasPrev) {
                    idx = state.data.prev.coIdx;
                    data = state.data.prev;
                } else if (gubun === 1 && state.hasNext) {
                    idx = state.data.next.coIdx;
                    data = state.data.next;
                }

                if (state.data.consultDepartmentF !== user.userInfo.team && user.userInfo.auth < 8) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "접근 권한이 없습니다.";
                    state.isShowModal = true;
                    return;
                }

                if (idx > 0 && data !== null) {
                    router.push({ name: "counselDetail", params: { id: state.clientIdx, idx: idx } });
                }
            };

            const addForTemporary = async () => {
                if (await checkRequiredValue()) {
                    const param: types.counsel.ReqCounsel = state.data;

                    param.newPrevSupportingExpensePrice =
                        Number(state.data.newPrevMedicalPrice) +
                        Number(state.data.newPrevLawPrice) +
                        Number(state.data.newPrevJobTrainingPrice) +
                        Number(state.data.newPrevNotGraspPrice);

                    Object.assign(param, state.data.counselDetailVO);

                    param.date = param.date.replaceAll("-", "");
                    const res = await apiService.counselForTemporary.add(state.clientIdx, param);
                    if (res.returnCode === 0) {
                        state.modalTab = 3;
                        state.modalTitle = "알림";
                        state.modalContent = "등록되었습니다.";
                        state.isShowModal = true;
                        state.gubun = 3;
                    } else {
                        console.error(res.description);
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            return {
                router,
                state,
                reset,
                confirmModify,
                confirmRemove,
                confirmModify2,
                confirmModify3,
                CommonUtils,
                CommonOptions,
                setDateToToday,
                closeModal,
                callBackModal,
                showRequestAccessModal,
                add,
                window,
                onChangeDate,
                showRejectReason,
                anotherDetail,
                addForTemporary,
            };
        },
    };
</script>
<style>
    .area_row {
        border-right: 1px solid #d9d9d9;
        border-left: 1px solid #d9d9d9;
    }

    .textarea_wrap textarea {
        min-height: 150px;
    }
</style>
